import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { Header as BaseHeader } from 'theme-ui';

export default function HeaderWrapper({ ...rest }) {
  return <Navbar as={BaseHeader} expand="lg" {...rest} />;
}
